const AUDIENCE_DATA_TYPE_MODE = {
    ALL: 'ALL',
    FIRST_PARTY: 'FIRST_PARTY',
    THIRD_PARTY: 'THIRD_PARTY',
};

export default AUDIENCE_DATA_TYPE_MODE;
